import Loadable from '@/components/Loadable'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const ClinicalStaff = Loadable(
  lazy(() => import('../pages/ClinicalStaff/ClinicalStaff.page')),
  true,
)

const ClinicalStaffForm = Loadable(
  lazy(() => import('../pages/ClinicalStaffForm/ClinicalStaffForm.page')),
  true,
)

const DutyShift = Loadable(
  lazy(() => import('../pages/DutyShift/DutyShift.page')),
  true,
)

const DutyShiftForm = Loadable(
  lazy(() => import('../pages/DutyShiftForm/DutyShiftForm.page')),
  true,
)

const AbsenceRescheduleLog = Loadable(
  lazy(() => import('../pages/AbsenceRescheduleLog/AbsenceRescheduleLog.page')),
  true,
)

const DutyShiftHours = Loadable(
  lazy(() => import('../pages/DutyShiftHours/DutyShiftHours.page')),
  true,
)

const ProfessionalsRoutes: RouteObject = {
  children: [
    {
      path: '/corpo-clinico',
      element: <ClinicalStaff />,
    },
    {
      path: '/corpo-clinico/cadastro',
      element: <ClinicalStaffForm />,
    },
    {
      path: '/corpo-clinico/editar/:id',
      element: <ClinicalStaffForm />,
    },
    {
      path: '/plantoes',
      element: <DutyShift />,
    },
    {
      path: '/plantoes/cadastro',
      element: <DutyShiftForm />,
    },
    {
      path: '/plantoes/editar/:id',
      element: <DutyShiftForm />,
    },
    {
      path: '/reagendamentos-ausencia',
      element: <AbsenceRescheduleLog />,
    },
    {
      path: '/plantoes/gestao-horas',
      element: <DutyShiftHours />,
    },
  ],
}

export default ProfessionalsRoutes
